import { render, staticRenderFns } from "./basicNoSideMenu.vue?vue&type=template&id=8e9dbc1c&scoped=true"
import script from "./basicNoSideMenu.vue?vue&type=script&lang=ts"
export * from "./basicNoSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./basicNoSideMenu.vue?vue&type=style&index=0&id=8e9dbc1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9dbc1c",
  null
  
)

export default component.exports